import React from 'react';
import './assets/scss/main.scss';
import dotenv from 'dotenv';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Header } from './components';
import Container from './components/Container';

import {
  CartScreen, HomeScreen, LoginScreen,
  OrderPlacedScreen, PaymentScreen, PlaceOrderScreen,
  ProductScreen, RegisterScreen, CheckoutScreen,
  UserActivationScreen, OrderScreen, ProfileScreen,
  UserInfoScreen, ChangePasswordScreen, UserOrderListScreen,
  UserAddressScreen, NotFoundScreen,
} from './screens';
import Sidebar from './ScreenComponents/Sidebar/Sidebar';
import Footer from './components/Footer/Footer';
import Shop from './screens/Shop';
import SssTest from './screens/SssTest';
import WishlistScreen from './screens/WishlistScreen';
import ConfirmedOrder from './screens/ConfirmedOrder';
import { ToastNotify } from './ScreenComponents/ShearCompo/ToastNotify/ToastNotify';

const App = () => {
  dotenv.config();

  return (
    <Router>
      <div className='d-flex'>
        <Sidebar />
        <div className='w-100'>
          <Header />
          <main>
            <Container>
              <AnimatePresence exitBeforeEnter>
                <Routes>
                  <Route path='/' element={<HomeScreen />} />
                  <Route path='/shop' element={<Shop />} />
                  <Route path='/search/:keyword' element={<HomeScreen />} />
                  <Route path='product/:id' element={<ProductScreen />} />
                  <Route path='/cart' element={<CartScreen />} />
                  <Route path='/wishlist' element={<WishlistScreen />} />
                  <Route path='/checkout' element={<CheckoutScreen />} />
                  <Route path='/order/confirmed' element={<ConfirmedOrder />} />
                  <Route path='/test' element={<SssTest />} />
                  <Route path='/payment' element={<PaymentScreen />} />
                  <Route path='/placeorder' element={<PlaceOrderScreen />} />
                  <Route path='/order' element={<OrderScreen />} />
                  <Route path='/order/:id' element={<OrderScreen />} />
                  <Route path='/order/:id/success' element={<OrderPlacedScreen />} />
                  <Route path='/register' element={<RegisterScreen />} />
                  <Route path='/user/active/:token' element={<UserActivationScreen />} />
                  <Route path='/login' element={<LoginScreen />} />
                  <Route path='/profile' element={<ProfileScreen />} >
                    <Route path='' element={<UserInfoScreen />} />
                    <Route path='address' element={<UserAddressScreen />} />
                    <Route path='orderlist' element={<UserOrderListScreen />} />
                    <Route path='change-password' element={<ChangePasswordScreen />} />
                  </Route >
                  <Route path='*' element={<NotFoundScreen />} />
                </Routes>
              </AnimatePresence>
            </Container>
          </main>
        </div>
      </div>
      <Footer />
      <ToastNotify />
    </Router>
  );
}

export default App;
